<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
  
    <CSidebarBrand class="d-md-down-none" to="/">
      <div class="img-container d-flex justify-content-left w-100">
        <img src="../assets/headerlogo.png">
      </div>
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="menu"/>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import coachMenu from './_coachMenu'
import adminMenu from './_adminMenu'
import { isAdmin, isCoach } from "@/helpers/utils.js";

export default {
  name: 'TheSidebar',
  coachMenu,
  adminMenu,
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    },
    menu(){
      return isAdmin() ? adminMenu : (isCoach() ? coachMenu : []);
    },
  }
}
</script>

<style scoped>
/deep/.img-container
{
  padding-left: 16px;
}

/deep/.img-container > img
{
  height: 30px;
  width: auto;
}
</style>